import { render, staticRenderFns } from "./BaseComposeEmailDialog.vue?vue&type=template&id=06dc0f1e&scoped=true&"
import script from "./BaseComposeEmailDialog.vue?vue&type=script&lang=js&"
export * from "./BaseComposeEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseComposeEmailDialog.vue?vue&type=style&index=0&id=06dc0f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc0f1e",
  null
  
)

export default component.exports